const CDN_URL = 'https://cdn.leroymerlin.ru/';
const CDN_CLOUD_NAME = 'lmru';
const ASSET_TYPE = 'image';
const DELIVERY_TYPE = 'upload';
const DEFAULT_TRANSFORMATIONS = 'd_photoiscoming.png';

export type Transformations = {
  width: number;
  height: number;
  objectFit?: 'fill' | 'pad' | 'fit';
  dpr?: '1.0' | '2.0' | '3.0';
};

enum TransformationNames {
  Width = 'width',
  Height = 'height',
  ObjectFit = 'objectFit',
  Dpr = 'dpr',
}

const TRANSFORMATIONS_MAP = {
  [TransformationNames.Width]: 'w_',
  [TransformationNames.Height]: 'h_',
  [TransformationNames.ObjectFit]: 'c_',
  [TransformationNames.Dpr]: 'dpr_',
};

export const buildImageUrl = (imagePath: string, transformations?: Transformations) => {
  const storagePath = `${CDN_URL}${CDN_CLOUD_NAME}`;
  const sourcePath = '/fudzi/elbrus/images/landings/';
  const basePath = `${storagePath}/${ASSET_TYPE}/${DELIVERY_TYPE}`;
  const baseTransformations = `f_auto,b_auto,${DEFAULT_TRANSFORMATIONS}`;

  if (!transformations || !transformations?.objectFit) {
    return `${basePath}/${baseTransformations},c_pad${sourcePath}${imagePath}`;
  }

  const customTransformations = (Object.keys(transformations) as TransformationNames[]).reduce(
    (acc, transformKey) => `${acc},${TRANSFORMATIONS_MAP[transformKey]}${transformations[transformKey]}`,
    baseTransformations
  );

  return `${basePath}/${customTransformations}${sourcePath}${imagePath}`;
};

export const enhanceImageUrl = (imagePath: string, transformations?: Transformations) => {
  const baseTransformations = `q_90,f_auto,b_auto,${DEFAULT_TRANSFORMATIONS},c_pad`;

  if (!transformations || !transformations?.objectFit) {
    return imagePath.replace(
      /upload|dam-storage/gm,
      (matched: string) => `${matched}/${baseTransformations}`
    );
  }

  const customTransformations = (Object.keys(transformations) as TransformationNames[]).reduce(
    (acc, transformKey) => `${acc},${TRANSFORMATIONS_MAP[transformKey]}${transformations[transformKey]}`,
    baseTransformations
  );

  return imagePath.replace(
    /upload|dam-storage/gm,
    (matched: string) => `${matched}/${customTransformations}`
  );
};
